<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{ isEditing ? 'Editar Usuario' : 'Crear Usuario' }}</h4>
          <p class="card-category">
            {{ isEditing ? 'Modifique los datos del usuario' : 'Complete el formulario para crear un nuevo usuario' }}
          </p>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>

          <form v-else @submit.prevent="saveUser">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Usuario</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.username"
                    :class="{ 'is-invalid': errors.username }"
                  >
                  <div v-if="errors.username" class="invalid-feedback">
                    {{ errors.username[0] }}
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Correo Electrónico</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="form.email"
                    :class="{ 'is-invalid': errors.email }"
                  >
                  <div v-if="errors.email" class="invalid-feedback">
                    {{ errors.email[0] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Número de CI</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.nro_ci"
                    :class="{ 'is-invalid': errors.nro_ci }"
                  >
                  <div v-if="errors.nro_ci" class="invalid-feedback">
                    {{ errors.nro_ci[0] }}
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>Nombres</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.nombres"
                    :class="{ 'is-invalid': errors.nombres }"
                  >
                  <div v-if="errors.nombres" class="invalid-feedback">
                    {{ errors.nombres[0] }}
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>Apellido Paterno</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.paterno"
                    :class="{ 'is-invalid': errors.paterno }"
                  >
                  <div v-if="errors.paterno" class="invalid-feedback">
                    {{ errors.paterno[0] }}
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>Apellido Materno</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.materno"
                    :class="{ 'is-invalid': errors.materno }"
                  >
                  <div v-if="errors.materno" class="invalid-feedback">
                    {{ errors.materno[0] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Cargo</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.cargo"
                    :class="{ 'is-invalid': errors.cargo }"
                  >
                  <div v-if="errors.cargo" class="invalid-feedback">
                    {{ errors.cargo[0] }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Contraseña {{ isEditing ? '(dejar en blanco para mantener)' : '' }}</label>
                  <input
                    type="password"
                    class="form-control"
                    v-model="form.password"
                    :class="{ 'is-invalid': errors.password }"
                  >
                  <div v-if="errors.password" class="invalid-feedback">
                    {{ errors.password[0] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Unidad</label>
                  <select
                    v-model="form.unidad"
                    class="form-select"
                    @change="onUnidadChange"
                    :class="{ 'is-invalid': errors.unidad }"
                    :disabled="loadingUnidades"
                  >
                    <option value="">Seleccione una unidad</option>
                    <option
                      v-for="unidad in unidades"
                      :key="unidad.id"
                      :value="unidad.id"
                    >
                      {{ unidad.codigo }} - {{ unidad.nombre_unidad }}
                    </option>
                  </select>

                  <div v-if="errors.unidad" class="invalid-feedback">
                    {{ errors.unidad[0] }}
                  </div>
                  <div v-if="loadingUnidades" class="text-muted small">
                    Cargando unidades...
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Seccion</label>
                  <select
                    class="form-select"
                    v-model="form.area"
                    :class="{ 'is-invalid': errors.area }"
                    :disabled="loadingAreas || !form.unidad"
                  >
                    <option value="">Seleccione una seccion</option>
                    <option
                      v-for="area in areas"
                      :key="area.id"
                      :value="area.id"
                    >
                      {{ area.codigo }} - {{ area.nombre_area }}
                    </option>
                  </select>

                  <div v-if="errors.area" class="invalid-feedback">
                    {{ errors.area[0] }}
                  </div>
                  <div v-if="loadingAreas" class="text-muted small">
                    Cargando secciones...
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Estado</label>
                  <select
                    class="form-select"
                    v-model="form.estado"
                    :class="{ 'is-invalid': errors.estado }"
                  >
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                  <div v-if="errors.estado" class="invalid-feedback">
                    {{ errors.estado[0] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Ventanilla asignada</label>
                  <select
                    class="form-select"
                    v-model="form.id_ventanilla_asignada"
                    :class="{ 'is-invalid': errors.id_ventanilla_asignada }"
                    :disabled="loadingVentanillas"
                  >
                    <option :value="null">Sin ventanilla</option>
                    <option
                      v-for="v in ventanillas"
                      :key="v.id"
                      :value="v.id"
                    >
                      {{ v.codigo }} - {{ v.nombre }}
                    </option>
                  </select>
                  <div v-if="errors.id_ventanilla_asignada" class="invalid-feedback">
                    {{ errors.id_ventanilla_asignada[0] }}
                  </div>
                  <div v-if="loadingVentanillas" class="text-muted small">
                    Cargando ventanillas...
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Roles</label>
                  <div class="roles-container">
                    <div v-for="role in roles" :key="role.id" class="form-check">
                      <input
                        type="checkbox"
                        :id="`role-${role.id}`"
                        :value="role.name"
                        v-model="form.roles"
                        class="form-check-input"
                      >
                      <label :for="`role-${role.id}`" class="form-check-label">
                        {{ role.name }}
                      </label>
                    </div>
                  </div>
                  <div v-if="errors.roles" class="text-danger">
                    {{ errors.roles[0] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 text-right">
                <router-link to="/users" class="btn btn-default">
                  Cancelar
                </router-link>
                <button type="submit" class="btn btn-primary" :disabled="saving">
                  {{ saving ? 'Guardando...' : 'Guardar' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    const form = ref({
      username: '',
      email: '',
      password: '',
      nro_ci: '',
      nombres: '',
      paterno: '',
      materno: '',
      cargo: '',
      unidad: '',
      area: '',
      estado: 'activo',
      id_ventanilla_asignada: null,
      roles: []
    });

    const roles = ref([]);
    const loading = ref(true);
    const saving = ref(false);
    const errors = ref({});
    const unidades = ref([]);
    const loadingUnidades = ref(true);
    const areas = ref([]);
    const loadingAreas = ref(false);
    const ventanillas = ref([]);
    const loadingVentanillas = ref(true);

    const userId = computed(() => route.params.id);

    const isEditing = computed(() => !!userId.value);

    const fetchUnidades = async () => {
      try {
        const response = await axios.get('/unidad/select');
        unidades.value = response.data.unidades;
      } catch (error) {
        console.error('Error al cargar unidades:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las unidades organizacionales'
        });
      } finally {
        loadingUnidades.value = false;
      }
    };

    const fetchAreas = async () => {
      if (!form.value.unidad) {
        areas.value = []; // Limpiar áreas si no hay unidad seleccionada
        form.value.area = '';
        return;
      }

      loadingAreas.value = true;
      try {
        const response = await axios.get('/area/select', {
          params: { id_unidad: form.value.unidad }
        });
        areas.value = response.data.areas || [];
      } catch (error) {
        console.error('Error al cargar secciones:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las secciones funcionales'
        });
      } finally {
        loadingAreas.value = false;
      }
    };

    // Al cambiar de unidad se reinicia la sección elegida y se recargan las secciones
    const onUnidadChange = () => {
      form.value.area = '';
      fetchAreas();
    };

    const fetchVentanillas = async () => {
      try {
        const response = await axios.get('/ventanillas/select');
        ventanillas.value = response.data.ventanillas || [];
      } catch (error) {
        console.error('Error al cargar ventanillas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las ventanillas'
        });
      } finally {
        loadingVentanillas.value = false;
      }
    };

    const fetchRoles = async () => {
      try {
        const response = await axios.get('/roles');
        roles.value = response.data.roles;
      } catch (error) {
        console.error('Error al cargar roles:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los roles'
        });
      }
    };

    const fetchUser = async () => {
      if (!isEditing.value) {
        loading.value = false;
        return;
      }

      try {
        const response = await axios.get(`/users/${userId.value}/show`);
        const user = response.data.user;

        form.value = {
          username: user.username,
          email: user.email,
          password: '',
          nro_ci: user.nro_ci,
          nombres: user.nombres,
          paterno: user.paterno,
          materno: user.materno,
          cargo: user.cargo,
          unidad: user.unidad,
          area: user.area,
          estado: user.estado,
          id_ventanilla_asignada: user.id_ventanilla_asignada ?? null,
          roles: user.roles.map(role => role.name)
        };
        if (user.unidad) {
          fetchAreas();
        }
      } catch (error) {
        console.error('Error al cargar usuario:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar el usuario'
        });
        router.push('/users');
      } finally {
        loading.value = false;
      }
    };

    const saveUser = async () => {
      saving.value = true;
      errors.value = {};

      try {
        let response;
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        };
        if (isEditing.value) {
          response = await axios.post(`/users/${userId.value}/edit`, form.value, config);
        } else {
          response = await axios.post('/users/create', form.value, config);
        }

        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });

        router.push('/users');
      } catch (error) {
        console.error('Error al guardar usuario:', error);

        if (error.response?.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'No se pudo guardar el usuario'
          });
        }
      } finally {
        saving.value = false;
      }
    };

    onMounted(async () => {
      await Promise.all([fetchRoles(), fetchUser(), fetchUnidades(), fetchVentanillas()]);
    });

    return {
      form,
      roles,
      loading,
      saving,
      errors,
      isEditing,
      saveUser,
      unidades,
      loadingUnidades,
      areas,
      fetchAreas,
      onUnidadChange,
      loadingAreas,
      ventanillas,
      loadingVentanillas,
    };
  }
};
</script>

<style scoped>
.roles-container {
  border: 1px solid #e9ecef;
  padding: 10px;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
}
</style>
